import { AxiosResponse } from 'axios';
import { api } from '../api';
import { GenericDeleteResponse, StandardResponse } from '../interfaces/Common';
import { PaginatedSubjects, PartialSubjectFormRequest, ReorderSubjectsResponse, Subject, SubjectFormRequest } from '../interfaces/Subject';
import { DEFAULT_PAGE_LIMIT } from '../../utils/constants';

export interface GetSubjectsParams {
    keyword?: string;
    page?: number;
    limit?: number;
    programId?: string;
}

export async function getSubjects(params?: GetSubjectsParams): Promise<StandardResponse<PaginatedSubjects>> {
    const response: AxiosResponse<StandardResponse<PaginatedSubjects>> = await api.get("/subjects", {
        params: {
            ...params,
            limit: params?.limit || DEFAULT_PAGE_LIMIT,
        }
    });
    return response.data;
}

export async function reorderSubjects(request: { programId: string; subjects: string[] }): Promise<StandardResponse<ReorderSubjectsResponse>> {
    const response: AxiosResponse<StandardResponse<ReorderSubjectsResponse>> = await api.post("/subjects/sequence", request);
    return response.data;
}

export async function createSubject(request: SubjectFormRequest): Promise<StandardResponse<Subject>> {
    const response: AxiosResponse<StandardResponse<Subject>> = await api.post("/subjects", request);
    return response.data;
}

export async function updateSubject(subjectId: string, request: PartialSubjectFormRequest): Promise<StandardResponse<Subject>> {
    const response: AxiosResponse<StandardResponse<Subject>> = await api.put(`/subjects/${subjectId}`, request);
    return response.data;
}

export async function deleteSubject(subjectId: string): Promise<StandardResponse<GenericDeleteResponse>> {
    const response: AxiosResponse<StandardResponse<GenericDeleteResponse>> = await api.delete(`/subjects/${subjectId}`);
    return response.data;
}